import { render, staticRenderFns } from "./AssignedComplaint.vue?vue&type=template&id=66b1951f"
import script from "./AssignedComplaint.vue?vue&type=script&lang=js"
export * from "./AssignedComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports